<form class="form-container">
    <div class="form-header">
        <div class="form-breadcrumb">
            <h3>Job In</h3>
        </div>
        <div class="form-actions">
            <button type="submit" mat-flat-button color="primary" (click)='confirmDialog()'>
                <mat-icon>save</mat-icon> Save
            </button>
        </div>
    </div>

    <div class="form-card">
        <div class="row">
            <div class="col-sm-4 mb-3">
                <mat-form-field appearance="fill" class="w-100">
                    <mat-label>Select Process</mat-label>
                    <mat-select (selectionChange)="onProcessChange($event)" [(value)]="selectedProcess" name='process_name'>
                        <input class="select-input" placeholder="Search..." type="text" autocomplete="nope" (keyup)="onProcessKey($event)" matInput name="process_list">
                        <mat-option *ngFor="let process of filteredProcesses" [value]="process">{{process.name}}</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>

        <div class="row" *ngIf="processSelected">
            <div class="col-sm-4 mb-3">
                <mat-form-field appearance="fill" class="w-100">
                    <mat-label>Scan Job Barcode</mat-label>
                    <input matInput type="text" autocomplete="off"
                           [(ngModel)]="jobBarcodeValue"
                           (keydown)="onJobBarcodeScan($event)"
                           placeholder="Scan job barcode..."
                           [disabled]="jobScanInProgress"
                           name="job_barcode_scan">
                    <mat-icon matPrefix>qr_code_scanner</mat-icon>
                    <mat-hint>Scan job order barcode or select from dropdown below</mat-hint>
                </mat-form-field>
            </div>
        </div>

        <div class="row" *ngIf="processSelected">
            <div class="col-sm-4 mb-3">
                <mat-form-field appearance="fill" class="w-100">
                    <mat-label>Select Job No.</mat-label>
                    <mat-select #job_id (selectionChange)="onJobChange($event)" [(value)]="selectedJob" (openedChange)="onJobScroll($event)" name='job_no'>
                        <input class="select-input" placeholder="Search..." type="text" autocomplete="off" (keydown)="$event.stopPropagation()" (keyup)="onJobKey($event)" matInput name="job_list">
                        <mat-option *ngFor="let job of allJobs" [value]="job">{{job.job_no}}</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>

        <div class="row" *ngIf="viewData">
            <div class="col-sm-4 mb-3">
                <mat-form-field appearance="fill" class="w-100">
                    <mat-label>Product Name</mat-label>
                    <input type="text" disabled matInput name="product_name" [(ngModel)]="product_name">
                </mat-form-field>
            </div>
        </div>

        <div class="row" *ngIf="viewData">
            <div class="col-sm-4 mb-3">
                <mat-form-field appearance="fill" class="w-100">
                    <mat-label>Doctor Name</mat-label>
                    <input type="text" disabled matInput name="doctor_name" [(ngModel)]="selectedJob.doctor.name">
                </mat-form-field>
            </div>
        </div>

        <div class="row" *ngIf="viewData">
            <div class="col-sm-4 mb-3">
                <mat-form-field appearance="fill" class="w-100">
                    <mat-label>Patient Name</mat-label>
                    <input type="text" disabled matInput name="patient_name" [(ngModel)]="selectedJob.patient_name">
                </mat-form-field>
            </div>
        </div>

        <div class="row" *ngIf="viewData && selectedJob.id">
            <div class="col-sm-4 mb-3">
                <label class="field-label">Attached Document</label>
                <div class="attached-doc">
                    <a target="_blank" href="/api/joborder/uploads/{{selectedJob.filename}}">{{selectedJob.filename}}</a>
                </div>
            </div>
        </div>

        <div *ngIf="viewData" class="comment-section">
            <h4 class="section-title">Leave a comment</h4>
            <div class="row">
                <div class="col-sm-6 mb-3">
                    <mat-form-field appearance="fill" class="w-100">
                        <mat-label>Your Comment</mat-label>
                        <textarea matInput rows="2" [(ngModel)]="comment_description" name="comment_description"></textarea>
                    </mat-form-field>
                </div>
            </div>

            <h4 class="section-title">Comments</h4>
            <div class="comments-list">
                <div class="comment-item" *ngFor="let comments of allComments">
                    <div class="comment-author">
                        <strong>{{comments.employee?.name}}</strong>
                        <span class="comment-date">{{ comments.created_at | date:'medium':'Asia/Kolkata' }}</span>
                    </div>
                    <p class="comment-text">{{comments.comment_description}}</p>
                </div>
            </div>
        </div>
    </div>
</form>